"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var dashboardContexts_1 = require("../../dashboardContexts");
var model_1 = require("../../../model");
var DefaultDashboardWidget_1 = require("./DefaultDashboardWidget");
var sdk_model_1 = require("@gooddata/sdk-model");
var dragAndDrop_1 = require("../../dragAndDrop");
var widgets_1 = require("../../../widgets");
var BadWidgetType = function () {
    return react_1.default.createElement("div", null, "Missing renderer");
};
var MissingWidget = function () {
    return react_1.default.createElement("div", null, "Missing widget");
};
/**
 * @internal
 */
exports.DashboardWidget = function (props) {
    var _a = dashboardContexts_1.useDashboardComponentsContext(), WidgetComponentProvider = _a.WidgetComponentProvider, KpiWidgetComponentSet = _a.KpiWidgetComponentSet, InsightWidgetComponentSet = _a.InsightWidgetComponentSet;
    var widget = props.widget, 
    // @ts-expect-error Don't expose index prop on public interface (we need it only for css class for KD tests)
    index = props.index;
    var WidgetComponent = react_1.useMemo(function () {
        // TODO: we need to get rid of this; the widget being optional at this point is the problem; the parent
        //  components (or possibly the model) should deal with layout items that have no valid widgets associated
        //  and thus short-circuit.
        if (!widget) {
            console.warn("Attempting render an undefined widget.");
            return MissingWidget;
        }
        var Component = WidgetComponentProvider(widget);
        // the default WidgetComponentProvider always returns something, DefaultDashboardWidget by default
        if (Component && Component !== DefaultDashboardWidget_1.DefaultDashboardWidget) {
            return Component;
        }
        if (widgets_1.isInitialPlaceholderWidget(widget)) {
            return dragAndDrop_1.EmptyDashboardDropZone;
        }
        if (widgets_1.isLoadingPlaceholderWidget(widget)) {
            return dragAndDrop_1.LoadingDashboardPlaceholderWidget;
        }
        if (widgets_1.isKpiPlaceholderWidget(widget) && KpiWidgetComponentSet.creating) {
            return KpiWidgetComponentSet.creating.CreatingPlaceholderComponent;
        }
        if (widgets_1.isInsightPlaceholderWidget(widget) && InsightWidgetComponentSet.creating) {
            return InsightWidgetComponentSet.creating.CreatingPlaceholderComponent;
        }
        if (sdk_model_1.isDashboardWidget(widget)) {
            return DefaultDashboardWidget_1.DefaultDashboardWidget;
        }
        console.warn("Unable to render widget " + model_1.extendedWidgetDebugStr(widget));
        return BadWidgetType;
    }, [widget]);
    return (react_1.default.createElement(WidgetComponent, tslib_1.__assign({}, props, { 
        // @ts-expect-error Don't expose index prop on public interface (we need it only for css class for KD tests)
        index: index })));
};
//# sourceMappingURL=DashboardWidget.js.map